var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "Model",
    {
      attrs: {
        form: _vm.form,
        "init-form": _vm.initForm,
        "is-show": _vm.isShowModel,
        "custom-title": _vm.dialogTitle,
        "save-item": _vm.saveItem,
        "can-submit": _vm.canSubmit,
        "is-only-confirm": _vm.mode === "view",
        "confirm-btn-text": _vm.mode === "view" ? "back" : "confirm",
        "auto-height": "",
      },
      on: {
        "update:isShow": function ($event) {
          _vm.isShowModel = $event
        },
        "update:is-show": function ($event) {
          _vm.isShowModel = $event
        },
      },
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: !_vm.canSubmit,
              expression: "!canSubmit",
            },
          ],
        },
        [
          _c(
            "el-form",
            {
              ref: "dataForm",
              attrs: { model: _vm.form, rules: _vm.rules, size: "small" },
            },
            [
              _vm.mode === "edit"
                ? [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          rules: _vm.rules.validateChoose,
                          label: _vm.$t("doubleWeekPlan.input.planRangeTime"),
                          "label-width": _vm.formLabelWidth,
                        },
                      },
                      [
                        _c("RangePick", {
                          attrs: {
                            "target-form": _vm.form,
                            "key-list": [
                              "planTaskStartTime",
                              "planTaskEndTime",
                            ],
                            "plan-task-date": _vm.info.planTaskDate,
                            "actual-plan-task-flag": _vm.actualPlanTaskFlag,
                            ptpk: _vm.info.planTaskInfoPk,
                            inline: "",
                            "picker-line": "",
                            disabled:
                              _vm.info.actualPlanTaskFlag ===
                              _vm.PT_STATUS_TASK,
                            mode: _vm.mode,
                          },
                        }),
                      ],
                      1
                    ),
                  ]
                : [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("common.startDatetime"),
                          "label-width": _vm.formLabelWidth,
                        },
                      },
                      [
                        _c("FormInput", {
                          attrs: {
                            val: _vm.info.planTaskStartTime,
                            mode: "view",
                          },
                          on: {
                            "update:val": function ($event) {
                              return _vm.$set(
                                _vm.info,
                                "planTaskStartTime",
                                $event
                              )
                            },
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("common.EndDatetime"),
                          "label-width": _vm.formLabelWidth,
                        },
                      },
                      [
                        _c("FormInput", {
                          attrs: {
                            val: _vm.info.planTaskEndTime,
                            mode: "view",
                          },
                          on: {
                            "update:val": function ($event) {
                              return _vm.$set(
                                _vm.info,
                                "planTaskEndTime",
                                $event
                              )
                            },
                          },
                        }),
                      ],
                      1
                    ),
                  ],
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("doubleWeekPlan.table.storeName"),
                    "label-width": _vm.formLabelWidth,
                  },
                },
                [
                  _c("FormInput", {
                    attrs: { val: _vm.info.storeName, mode: "view" },
                    on: {
                      "update:val": function ($event) {
                        return _vm.$set(_vm.info, "storeName", $event)
                      },
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("doubleWeekPlan.input.storeContact"),
                    "label-width": _vm.formLabelWidth,
                  },
                },
                [
                  _c("FormInput", {
                    attrs: { val: _vm.info.contactor, mode: "view" },
                    on: {
                      "update:val": function ($event) {
                        return _vm.$set(_vm.info, "contactor", $event)
                      },
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("doubleWeekPlan.table.storeCode"),
                    "label-width": _vm.formLabelWidth,
                  },
                },
                [
                  _c("FormInput", {
                    attrs: { val: _vm.info.storeCode, mode: "view" },
                    on: {
                      "update:val": function ($event) {
                        return _vm.$set(_vm.info, "storeCode", $event)
                      },
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("doubleWeekPlan.table.PCD"),
                    "label-width": _vm.formLabelWidth,
                  },
                },
                [
                  _c("FormInput", {
                    attrs: { val: _vm.info.PCD, mode: "view" },
                    on: {
                      "update:val": function ($event) {
                        return _vm.$set(_vm.info, "PCD", $event)
                      },
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("doubleWeekPlan.table.storeAddress"),
                    "label-width": _vm.formLabelWidth,
                  },
                },
                [
                  _c("FormInput", {
                    attrs: { val: _vm.info.storeAddress, mode: "view" },
                    on: {
                      "update:val": function ($event) {
                        return _vm.$set(_vm.info, "storeAddress", $event)
                      },
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("doubleWeekPlan.input.target1"),
                    "label-width": _vm.formLabelWidth,
                  },
                },
                [
                  _c("FormSelect", {
                    attrs: {
                      val: _vm.info.visitPurposeOne,
                      options: _vm.optConfig.visitPurposeOptions,
                      mode: "view",
                    },
                    on: {
                      "update:val": function ($event) {
                        return _vm.$set(_vm.info, "visitPurposeOne", $event)
                      },
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("doubleWeekPlan.input.target2"),
                    "label-width": _vm.formLabelWidth,
                  },
                },
                [
                  _c("FormSelect", {
                    attrs: {
                      val: _vm.info.visitPurposeTwo,
                      options: _vm.optConfig.visitPurposeOptions,
                      mode: "view",
                    },
                    on: {
                      "update:val": function ($event) {
                        return _vm.$set(_vm.info, "visitPurposeTwo", $event)
                      },
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _vm.info.roleType == "ASM"
                ? _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("doubleWeekPlan.input.asmVisitPurpose"),
                        "label-width": _vm.formLabelWidth,
                      },
                    },
                    [
                      _c("FormSelect", {
                        attrs: {
                          val: _vm.info.asmVisitPurpose,
                          options: _vm.optConfig.asmVisitPurposeOptions,
                          mode: "view",
                        },
                        on: {
                          "update:val": function ($event) {
                            return _vm.$set(_vm.info, "asmVisitPurpose", $event)
                          },
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("doubleWeekPlan.input.desc"),
                    "label-width": _vm.formLabelWidth,
                  },
                },
                [
                  _c("FormTextArea", {
                    attrs: {
                      val: _vm.form.remark,
                      rows: 4,
                      maxlength: "100",
                      mode: _vm.mode,
                      disabled:
                        _vm.info.actualPlanTaskFlag === _vm.PT_STATUS_TASK,
                    },
                    on: {
                      "update:val": function ($event) {
                        return _vm.$set(_vm.form, "remark", $event)
                      },
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _vm.info.roleType == "ASM" && _vm.info.actualPlanTaskFlag == "Y"
                ? _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("doubleWeekPlan.input.asmVisitSummary"),
                        "label-width": _vm.formLabelWidth,
                      },
                    },
                    [
                      _c("FormTextArea", {
                        attrs: {
                          val: _vm.form.asmVisitSummary,
                          rows: 4,
                          maxlength: "100",
                          mode: _vm.mode,
                          disabled:
                            _vm.info.actualPlanTaskFlag === _vm.PT_STATUS_TASK,
                        },
                        on: {
                          "update:val": function ($event) {
                            return _vm.$set(_vm.form, "asmVisitSummary", $event)
                          },
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            2
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("TimeConflictModel", {
        ref: "timeConflictModel",
        attrs: { "opt-config": _vm.optConfig },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }